import { Check, X, Heart, Users, Sparkles, Shield } from "lucide-react";
import { motion } from "framer-motion";

const REASONS = [
  {
    icon: Heart,
    title: "Odontología de autor",
    desc: "No somos franquicia. Cada tratamiento lo planifica y ejecuta el mismo doctor de principio a fin.",
  },
  {
    icon: Users,
    title: "Relación con el paciente",
    desc: "Siempre te atiende el mismo doctor. Conocemos tu historia clínica y la de tu familia.",
  },
  {
    icon: Sparkles,
    title: "Tecnología de última generación",
    desc: "TAC 3D, escáner intraoral digital, cirugía guiada. Precisión y comodidad garantizadas.",
  },
  {
    icon: Shield,
    title: "Presupuestos honestos",
    desc: "Sin sobretratamientos ni sorpresas. Te proponemos solo lo que realmente necesitas.",
  },
];

const COMPARISON = [
  { us: "Mismo doctor siempre", them: "Cambian cada cita" },
  { us: "Diagnóstico honesto", them: "Sobretratamientos" },
  { us: "40+ años de trayectoria", them: "Alta rotación de personal" },
  { us: "Compromiso a largo plazo", them: "Objetivos de venta" },
  { us: "Trato cercano y familiar", them: "Atención impersonal" },
];

export default function Differentiators() {
  return (
    <section className="py-24 bg-slate-50" data-testid="differentiators-section">
      <div className="container-max">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Reasons */}
          <div>
            <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-1.5 mb-5 border border-slate-200">
              <span className="text-xs font-semibold text-teal-700 uppercase tracking-wider">¿Por qué elegirnos?</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Somos una <span className="underline-accent">clínica familiar</span>, no una franquicia
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              En un mundo de cadenas low-cost, defendemos la odontología de autor:
              trato personal, compromiso a largo plazo y diagnósticos honestos.
            </p>

            <div className="space-y-3">
              {REASONS.map((r, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="flex gap-4 p-5 bg-white rounded-2xl border border-slate-200"
                  data-testid={`differentiator-${i}`}
                >
                  <div className="w-11 h-11 rounded-xl bg-teal-50 flex items-center justify-center shrink-0">
                    <r.icon className="w-5 h-5 text-teal-700" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">{r.title}</h3>
                    <p className="text-sm text-slate-600 leading-relaxed">{r.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Comparison */}
          <div className="lg:sticky lg:top-24">
            <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-sm">
              <div className="grid grid-cols-2">
                <div className="bg-teal-700 text-white p-6">
                  <div className="text-xs font-semibold uppercase tracking-wider text-teal-200 mb-1">Nosotros</div>
                  <div className="font-bold text-lg">Clínica Dental Pina</div>
                </div>
                <div className="bg-slate-100 text-slate-600 p-6">
                  <div className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">Franquicias</div>
                  <div className="font-bold text-lg">Cadenas low-cost</div>
                </div>
              </div>
              <div className="divide-y divide-slate-100">
                {COMPARISON.map((c, i) => (
                  <div key={i} className="grid grid-cols-2">
                    <div className="p-4 flex items-center gap-2.5 bg-teal-50/50">
                      <div className="w-5 h-5 rounded-full bg-teal-700 flex items-center justify-center shrink-0">
                        <Check className="w-3 h-3 text-white" strokeWidth={3} />
                      </div>
                      <span className="text-sm font-medium text-slate-900">{c.us}</span>
                    </div>
                    <div className="p-4 flex items-center gap-2.5 opacity-70">
                      <div className="w-5 h-5 rounded-full bg-slate-300 flex items-center justify-center shrink-0">
                        <X className="w-3 h-3 text-white" strokeWidth={3} />
                      </div>
                      <span className="text-sm text-slate-600 line-through">{c.them}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
